// extracted by mini-css-extract-plugin
module.exports = {"title":"delete_review__title___UNSzF _type__vx_text-2___Qizsf","delete-button":"delete_review__delete-button___384_e"};